'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function MissionSection() {
  const [showValues, setShowValues] = useState(false);

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full mb-6">
              <Icon name="SparklesIcon" size={20} className="text-accent" variant="solid" />
              <span className="text-sm font-semibold text-accent">Who We Are</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
              Ending Food Deserts Nationwide
            </h2>
            
            <div className="space-y-4 text-lg text-text-secondary">
              <p>The Food For Thought Foundation is a 501(c)(3) nonprofit organization.

Founded in December, 2020 FFTF started off by impacting food insecurity in Wards 7 & 8 of DC through various programs and now is expanding regionally and aiming nationwide.</p>
            </div>
            
            <button
              onClick={() => setShowValues(!showValues)}
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-brand-primary text-white font-semibold rounded-lg hover:bg-brand-primary/90 transition-all duration-300">

              <span>Learn About Our Values</span>
              <Icon
                name={showValues ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                size={20} />

            </button>

            {showValues &&
            <div className="mt-8 p-6 bg-gradient-to-br from-brand-primary/5 to-brand-primary/10 rounded-xl border-l-4 border-brand-primary animate-slide-in-right">
                <h3 className="text-xl font-bold text-text-primary mb-4">Our Core Values</h3>
                <ul className="space-y-3 text-text-secondary">
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-brand-primary flex-shrink-0" variant="solid" />
                    <span>Community-centered approach to food security</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-brand-primary flex-shrink-0" variant="solid" />
                    <span>Sustainable and resilient resource distribution</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-brand-primary flex-shrink-0" variant="solid" />
                    <span>Empowerment through reliable access to nutrition</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-brand-primary flex-shrink-0" variant="solid" />
                    <span>Creating lasting solutions, not temporary fixes</span>
                  </li>
                </ul>
              </div>
            }
          </div>
          
          <div className="bg-gradient-to-br from-brand-primary/10 via-background to-accent/5 rounded-2xl p-8 lg:p-12">
            <div className="mb-8">
              <Icon name="HeartIcon" size={48} className="text-brand-primary mb-4" variant="solid" />
              <h3 className="text-2xl font-bold text-text-primary mb-4">Our Mission Statement</h3>
              <p className="text-xl text-text-primary font-semibold leading-relaxed">
                To empower food insecure communities with resilient and reliable resources.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-8">
              <div className="bg-white rounded-xl p-4 shadow-brand-md">
                <Icon name="MapPinIcon" size={32} className="text-accent mb-2" variant="solid" />
                <h4 className="text-sm font-semibold text-text-primary mb-1">Wards 7 & 8</h4>
                <p className="text-xs text-text-secondary">Primary service area in DC</p>
              </div>
              
              <div className="bg-white rounded-xl p-4 shadow-brand-md">
                <Icon name="CalendarIcon" size={32} className="text-success mb-2" variant="solid" />
                <h4 className="text-sm font-semibold text-text-primary mb-1">Since 2020</h4>
                <p className="text-xs text-text-secondary">Fighting food insecurity</p>
              </div>
              
              <div className="bg-white rounded-xl p-4 shadow-brand-md">
                <Icon name="UsersIcon" size={32} className="text-brand-secondary mb-2" variant="solid" />
                <h4 className="text-sm font-semibold text-text-primary mb-1">Community</h4>
                <p className="text-xs text-text-secondary">Centered approach</p>
              </div>
              
              <div className="bg-white rounded-xl p-4 shadow-brand-md">
                <Icon name="SparklesIcon" size={32} className="text-brand-primary mb-2" variant="solid" />
                <h4 className="text-sm font-semibold text-text-primary mb-1">Solutions</h4>
                <p className="text-xs text-text-secondary">Creating lasting impact</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}